import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Created Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "prepend",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Updated Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const remove = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/${args?.id}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Deleted successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/${args?.id}`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "zones",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);

    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const getCharges = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/${args?.id}/charges`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const updateCharges = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/${args?.id}/charges`,
      method: "put",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Charges Updated Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const getSurgePrice = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/${args?.id}/surges`,
      method: "get",
      authorization: true,
      config: {
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const updateSurgePrice = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/${args?.id}/surges`,
      method: "post", // Changed to post for adding new
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Surge Price Added Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const patchSurgePrice = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/surges/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Surge Price Updated Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const removeSurgePrice = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `zones/surges/${args?.id}`,
      method: "delete",
      authorization: true,
      config: {
        successMsg: "Surge Price Removed Successfully",
        showErr: true,
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default {
  find,
  list,
  create,
  update,
  remove,
  getCharges,
  updateCharges,
  getSurgePrice,
  updateSurgePrice,
  patchSurgePrice,
  removeSurgePrice,
};
